document.addEventListener('DOMContentLoaded', function() {
    // Parse query parameters
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    const product = params.get('product');
    const contactMessage = params.get('contactMessage');
    const contactType = params.get('contactType');
  
    // 1. Auto-select "Request a Quote" in the dropdown
    if (type) {
      // Find the select by name attribute
      const select = document.querySelector('select[name="contact[how-can-we-help]"]');
      if (select) {
        // Set value to "Request a Quote"
        const option = Array.from(select.options).find(opt => opt.value.trim().toLowerCase() === type);
        if (option) {
          select.value = option.value;
        }
      }
    }

    // 1b. Auto-select based on contactType parameter
    if (contactType) {
      // Find the select by name attribute
      const select = document.querySelector('select[name="contact[how-can-we-help]"]');
      if (select) {
        // Look for option that matches the contactType value
        const option = Array.from(select.options).find(opt => 
          opt.value.trim().toLowerCase() === contactType.toLowerCase() ||
          opt.textContent.trim().toLowerCase() === contactType.toLowerCase()
        );
        if (option) {
          select.value = option.value;
        }
      }
    }

    // 1c. Pre-fill contact message if provided
    if (contactMessage) {
      const messageField = document.querySelector('textarea[name="contact[Message]"], textarea[name="contact[message]"], #contact_form-body');
      if (messageField) {
        messageField.value = decodeURIComponent(contactMessage);
      }
    }
  
    // 2. Add hidden product field
    if (product) {
      // Find the form
      const form = document.querySelector('form[action*="contact"]');
      if (form) {
        // Check if already present
        if (!form.querySelector('input[name="contact[product]"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[product]';
          input.value = product;
          form.appendChild(input);
        }
      }
    }
  });